import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import classnames from 'classnames';

import EdmundsLogo from 'client/images/edmunds-logo-226.png';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

import { TopRatedCarousel } from './top-rated-carousel';
import { TopRatedItem } from './top-rated-item';
import './top-rated-module.scss';

export function TopRatedModule({ content, isMobile = false, className = null }) {
  const cards = content.children();

  return (
    <section className={classnames('top-rated-module', { container: !isMobile }, className)}>
      <header>
        <figure
          className="d-inline-block pb-0_5 mb-1_5"
          style={{
            borderBottom: '2px solid #007EE5',
          }}
        >
          <img loading="lazy" src={EdmundsLogo} alt="" height={isMobile ? 21 : 33} />
        </figure>
        <h2 className={classnames({ 'mb-1': isMobile, 'd-flex align-items-center mb-0_5': !isMobile })}>
          <img
            loading="lazy"
            height={isMobile ? 26 : 37}
            className={classnames({ 'mb-0_5': isMobile, 'me-1': !isMobile })}
            src={getStaticImageUrl('/img/top-rated/top-rated-black-text.svg')}
            alt="Top rated"
          />
          <span className="trm-header">Spotlight</span>
        </h2>
        <ContentFragment classes={classnames('size-24', { 'mb-2_5': isMobile, 'mb-3': !isMobile })}>
          {content.summary}
        </ContentFragment>
      </header>

      {isMobile ? (
        <Fragment>
          <TopRatedCarousel className="mb-2_5">
            {cards.slice(0, 3).map(card => (
              <TopRatedItem content={card} key={card.metadata('title').value()} />
            ))}
          </TopRatedCarousel>
          <TopRatedCarousel>
            {cards.slice(3).map(card => (
              <TopRatedItem content={card} key={card.metadata('title').value()} />
            ))}
          </TopRatedCarousel>
        </Fragment>
      ) : (
        <Row>
          {cards.map(card => (
            <Col xs={12} md={4} className="mb-2" key={card.metadata('title').value()}>
              <TopRatedItem content={card} />
            </Col>
          ))}
        </Row>
      )}
    </section>
  );
}

TopRatedModule.propTypes = {
  content: CmsEntities.Content.isRequired,
  isMobile: PropTypes.bool,
  className: PropTypes.string,
};
